
import styles from "./SpectacleExtraArticles.module.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "services/api";
import CardSpectacle from "./CardSpectacle";

const SpectacleDetailExtra = ({ categorieId, excludedEventSlug }) => {
  const [spectacles, setSpectacles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProgrammeData = async () => {
      try {
        const response = await api.get(`/spectacles/read/${categorieId}`);
        const spectacles = response.data;
        setSpectacles(spectacles);
        console.log("Spectacles récupérés :", spectacles);

      } catch (error) {
        console.error("Erreur lors de la récupération des données des spectacles pour le programme :", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProgrammeData();
  }, []);

  return (
    <div className={styles.extraArticles}>
      <h2 className={styles.extraTitle}>Vous aimerez peut-être aussi</h2>
      {spectacles && spectacles.length > 0 ? (
        <ul className={`${styles.spectacleList}`}>
          {spectacles.filter(event => event.slug !== excludedEventSlug).slice(0, 4).map((spectacle) => (
            <CardSpectacle
              key={spectacle.id}
              name={spectacle.name}
              plage_date={spectacle.plage_date}
              description={spectacle.shortDescription}
              poster={spectacle.poster}
              typeShow={spectacle.typeShow}
              link={`/programme/${spectacle.typeShow.code}/${spectacle.slug}`}
            />
          ))}
        </ul>
      ) : (
        <p>Aucune page trouvée pour cette catégorie.</p>
      )}
    </div >
  )
}


export default SpectacleDetailExtra;
